<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{data.sysText.editEmployerCaseComSettings_title | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-select-field
      [control]="form.controls.restrictToWorkEmail"
      [label]="data.sysText.restrictToWorkEmail_title"
      [options]="yesNoOptions"
      [showBlankOption]="true"
      [shouldCapitalize]="false"
      [hint]="restrictToWorkEmailHint"
      [isHintHighlighted]="false"
      [icon]="'alternate_email'"
      [info]="data.sysText.restrictToWorkEmail_info">
    </app-select-field>
    <app-text-area
      [control]="form.controls.automaticCcAddresses"
      [label]="data.sysText.automaticCcAddresses_title"
      [icon]="'email'"
      [info]="data.sysText.automaticCcAddresses_info"
    ></app-text-area>
    <app-text-area
      [control]="form.controls.automaticBccAddresses"
      [label]="data.sysText.automaticBccAddresses_title"
      [icon]="'email'"
      [info]="data.sysText.automaticBccAddresses_info"
    ></app-text-area>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close(false)">
      {{data.sysText.cancel}}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{data.sysText.save}}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

